export default __webpack_public_path__ + "static/media/Jersey-M54.b9b9f8b7.ttf";